import { IChuongTrinhDaoTaoViewModel } from "../../../model/response/chuong-trinh-dao-tao/IChuongTrinhDaoTaoViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChuongTrinhDaoTaoActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IChuongTrinhDaoTaoViewModel[],
    LOAD_ERROR: "",

    CHANGE_CTDT_SELECTED: {} as IChuongTrinhDaoTaoViewModel | undefined,

    UPLOAD_CONG_THUC_MODAL_OPEN: undefined,
    UPLOAD_CONG_THUC_MODAL_CLOSE: undefined,

};
export const eChuongTrinhDaoTaoActionIds = generateActionTypeIds(
    eChuongTrinhDaoTaoActionsObj,
    "CHUONG_TRINH_DAO_TAO"
);
export type IChuongTrinhDaoTaoActionTypes = IGenericActionType<
    typeof eChuongTrinhDaoTaoActionsObj,
    "CHUONG_TRINH_DAO_TAO"
>;
